import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { nextSicuro } from '@/lib/nav';
import { Loader2, AlertCircle } from 'lucide-react';

const LOGO_BLACK = '/logo-biounica-nero.png';

export default function MagicLinkPage() {
  const { confirmMagicLink } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState('');
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get('token');
    if (!token) {
      setError('Link non valido.');
      return;
    }
    const dest = nextSicuro(params.get('next')) || '/dashboard';
    confirmMagicLink(token)
      .then(() => navigate(dest, { replace: true }))
      .catch((err) => setError(err.response?.data?.detail || 'Link non valido o scaduto.'));
  }, [params, confirmMagicLink, navigate]);

  return (
    <div className="min-h-screen bg-[#efe8da] flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <img src={LOGO_BLACK} alt="Biounica" className="h-14 mx-auto mb-6" />
        {error ? (
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-7 h-7 text-red-500" />
            </div>
            <h2 className="font-heading text-xl font-semibold text-[#12100c] mb-2">Accesso non riuscito</h2>
            <p className="text-sm text-[#4a4238] mb-6">{error}</p>
            <Link to="/login" className="text-[#4a5f43] font-medium hover:underline text-sm">
              Torna al login
            </Link>
          </div>
        ) : (
          <div className="flex flex-col items-center text-[#12100c]">
            <Loader2 className="w-8 h-8 animate-spin mb-3" />
            <p className="text-sm">Accesso in corso...</p>
          </div>
        )}
      </div>
    </div>
  );
}
